export const userType = {
    individual: 'individual',
    thirdParty: "3pl"
}